import { createSlice } from '@reduxjs/toolkit'
import { OptionObject } from 'app/types/types'

type InitialState = {
  rules: OptionObject[]
  template: OptionObject[]
  dataType: OptionObject[]
  fileType: OptionObject[]
  fileStatus: OptionObject[]
  templateStatus: OptionObject[]
  fileSource: OptionObject[]
  templateSource: OptionObject[]
}

const initialState: InitialState = {
  rules: [],
  template: [],
  dataType: [],
  fileType: [],
  fileStatus: [],
  templateStatus: [],
  fileSource: [],
  templateSource: [],
}

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    getRules: (state, action) => {
      const { rules } = action.payload
      state.rules = rules
    },
    getTemplateList: (state, action) => {
      const { template } = action.payload
      state.template = template
    },
    getDataType: (state, action) => {
      const { dataType } = action.payload
      state.dataType = dataType
    },
    getFileType: (state, action) => {
      const { fileType } = action.payload
      state.fileType = fileType
    },
    getFileStatus: (state, action) => {
      const { fileStatus } = action.payload
      state.fileStatus = fileStatus
    },
    getTemplateStatus: (state, action) => {
      const { templateStatus } = action.payload
      state.templateStatus = templateStatus
    },
    getFileSource: (state, action) => {
      const { fileSource } = action.payload
      state.fileSource = fileSource
    },
    getTemplateSource: (state, action) => {
      const { templateSource } = action.payload
      state.templateSource = templateSource
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  getRules,
  getTemplateList,
  getDataType,
  getFileType,
  getFileStatus,
  getTemplateStatus,
  getFileSource,
  getTemplateSource,
} = commonSlice.actions

export default commonSlice.reducer
